import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { apiRoute, stateEnum } from "../constants/enum.js"
import customAPI from "../api/customAPI.js"
const { salesOrder } = stateEnum
let initialState = {
  billno: "",
  acid: "",
  detailParams: {},
  isNewEntry: true,
  orderData:[]
}
export const setSaleOrderDetail = createAsyncThunk(
  "saleOrder/fetchSaleOrderDetail",
  async ({ token, compcode, orderno, billtype, db_user }) => {
    try {
      
      const { data } = await customAPI.post(
        apiRoute.transaction.salesOrderEntry.getOrderDetail,
        {
          comp_code: compcode,
          order_no: orderno,
          bill_type: billtype,
          db_user: db_user
        },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )

      return data.data
    } catch (error) {
      console.log(error)
    }
  }
)

const salesOrderEntrySlice = createSlice({
  name: salesOrder,
  initialState,
  reducers: {

    resetDetailParams: (state) => {
      state.detailParams = {}
      state.isNewEntry = true
    },
    
    setDetailParams: (state, action) => {
      state.detailParams = action.payload
    },
    setNewEntry: (state, action) => {
      state.isNewEntry = action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(setSaleOrderDetail.fulfilled, (state, action) => {
        
        state.orderData = action.payload
      })
      .addCase(setSaleOrderDetail.rejected, (state, action) => {
        state.orderData = []
      })
  },
})
export const { resetDetailParams,setDetailParams, setNewEntry } = salesOrderEntrySlice.actions
export default salesOrderEntrySlice.reducer
